export class LoginPageUserBrandingSettings {
    constructor(public headerImageUrl: string = "https://icpublicuploads.s3-eu-west-1.amazonaws.com/global/login/headerImage.png", public headerText: string = "Evrideo", public faviconUrl: string = "https://icpublicuploads.s3-eu-west-1.amazonaws.com/global/login/favicon.png",public windowTitle: string = "Evrideo Dashboard") {
    }

    public static FromRawObject(raw: any): LoginPageUserBrandingSettings{
        return new LoginPageUserBrandingSettings(raw.headerImageUrl,raw.headerText,raw.faviconUrl,raw.windowTitle);
    }
}
